import { Game } from 'model/game/types';

/**
 * Get the opposite player color as a number.
 */
export function getOppositeColor(color: Game.ColorsAsNumbers): Game.ColorsAsNumbers {
  return color === Game.ColorsAsNumbers.Black
    ? Game.ColorsAsNumbers.White
    : Game.ColorsAsNumbers.Black;
}
